import React, { useEffect, useState } from 'react';
import TableAccountsList from '@/components/dashboard/TableAccountsList';
import SearchBar from '@/components/searchBar/SearchBarAccounts';
import { TUsersList } from '@/api/DashboardTypes'; // S'assurer que cette importation est correcte
import axios from 'axios';

export interface TAccountsList {
  id: string;
  nom: string;
  prenom: string;
  tag: string;
  statut: "Active" | "Desactive";
  dateCreation: string;
  clinique: string;
}

const DashboardAccounts: React.FC = () => {
  const [data, setData] = useState<TUsersList[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAccounts, setFilteredAccounts] = useState<TUsersList[]>([]);
  
  const api = axios.create({
    withCredentials: true // Important pour les sessions et les cookies
  });

  useEffect(() => {
    api.get('/dashboard/users')
      .then(response => {
        setData(response.data);
        setFilteredAccounts(response.data); // Initialement, tous les comptes sont visibles
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des données:", error);
      });
  }, []);

  useEffect(() => {
    const filterData = () => {
      const searchTerms = searchTerm.toLowerCase().split(" ").filter(term => term.trim() !== "");
      const filtered = data.filter(account =>
        searchTerms.every(term =>
          account.firstName.toLowerCase().includes(term) ||
          account.lastName.toLowerCase().includes(term) ||
          account.role.toLowerCase().includes(term) ||
          (account.clinic?.toLowerCase() || "").includes(term)
        )
      );
      setFilteredAccounts(filtered);
    };

    if (searchTerm) {
      filterData();
    } else {
      setFilteredAccounts(data);
    }
  }, [searchTerm, data]);

  return (
    <div>
      <SearchBar onSearchChange={setSearchTerm} />
      <div className="w-full flex justify-center">
        <TableAccountsList AccountsList={filteredAccounts} />
      </div>
    </div>
  );
}

export default DashboardAccounts;
